import ArrowLeftRoundedIcon from '@mui/icons-material/ArrowLeftRounded';
import ArrowRightRoundedIcon from '@mui/icons-material/ArrowRightRounded';
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/system";
import axios from "axios";
import React, { Component } from "react";
import Carousel from 'react-material-ui-carousel';
import { Bar, BarChart, Cell, LabelList, ResponsiveContainer, ReferenceLine } from "recharts";
import LoaderCard from "../components/ui-components/LoaderCard";
import wyzrTheme from "../styles/customTheme";
import { getURLBase } from "../utils/helperFns";

class ThisMonth extends Component {
    constructor(props) {
        super(props);
        this.url = getURLBase(true) + "/thismonth";
        this.state = {
            isReady: false,
            isBarChartReady: false,
            monthsArray: [],
        };
    }

    mockData = [
        {
            data: [
                {
                    amt: 6598,
                    name: "Income"
                },
                {
                    amt: -125.57,
                    name: "Spending(debit)"
                },
                {
                    amt: -1000,
                    name: "Spending(credit)"
                },
                {
                    amt: 400.57,
                    name: "Remaining from income"
                }
            ],
            monthName: "Feb-22"
        },
        {
            data: [
                {
                    amt: 398,
                    name: "Income"
                },
                {
                    amt: -1225.57,
                    name: "Spending(debit)"
                },
                {
                    amt: -855,
                    name: "Spending(credit)"
                },
                {
                    amt: 655.57,
                    name: "Remaining from income"
                }
            ],
            monthName: "Mar-22"
        },
        {
            data: [
                {
                    amt: 0,
                    name: "Income"
                },
                {
                    amt: -548,
                    name: "Spending(debit)"
                },
                {
                    amt: -865,
                    name: "Spending(credit)"
                },
                {
                    amt: 0,
                    name: "Remaining from income"
                }
            ],
            monthName: "Mar-22"
        }
    ]

    componentDidMount() {
        if (!this.state.isReady) {
            axios.post(this.url, { gid: this.props.gid }).then((response) => {
                var singleData = response.data.body.data;
                this.setState({
                    isReady: true,
                    monthsArray: singleData,
                    carouselIndex: singleData.length - 1
                });
            });
        }
    }

    render() {
        return (
            this.state.isReady ? (
                <Carousel className="w-100" autoPlay={false} animation="slide"
                    index={this.state.carouselIndex}
                    navButtonsAlwaysVisible={"auto"} cycleNavigation={false}
                    indicators={false}
                    navButtonsProps={{
                        className: "owlNavButton",
                        style: {
                            backgroundColor: 'transparent',
                            color: "#82B879",
                            fontSize: 50,
                        }
                    }}
                    activeIndicatorIconButtonProps={{
                        style: {
                            color: '#82B879'
                        }
                    }}
                    PrevIcon={<ArrowLeftRoundedIcon fontSize="inherit" />}
                    NextIcon={<ArrowRightRoundedIcon fontSize="inherit" />}
                >
                    {
                        this.state.monthsArray.map((item, i) =>
                        (
                            <Card className="widgetCard cardShadow" key={i}>
                                <CardContent textAlign="center" style={{ paddingBottom: "3rem !important" }}>
                                    <Typography variant="h4" sx={{ fontWeight: 700 }} align="center" mb={3} mx={"auto"} width="70%">
                                        {item.monthName}
                                    </Typography>
                                    <Box
                                        className="flex-center-all"
                                        sx={{ flexDirection: "column", padding: 0, maxWidth: 500, marginX: "auto" }}
                                    >
                                        <ResponsiveContainer width="100%" height={200}>
                                            <BarChart width="100%" height="100%" data={item.data}
                                                margin={{
                                                    top: 10,
                                                    bottom: 40,
                                                }}
                                            >
                                                <ReferenceLine y="0" stroke={wyzrTheme.palette.grey[400]} />
                                                <Bar
                                                    dataKey="amt"
                                                    fill="#8884d8"
                                                    minPointSize={0}
                                                    barSize={30}
                                                    radius={[10, 10, 0, 0]}
                                                    isAnimationActive={false}
                                                    cursor="pointer"
                                                >
                                                    <LabelList dataKey="name" fill={wyzrTheme.palette.grey[600]} className="label-small" position={'bottom'} offset={10} />
                                                    <LabelList dataKey="amt" position="top" offset={10} style={{ fontSize: "0.9rem", fontWeight: 700, fill: "#000" }} />
                                                    {this.state.isReady && item.data.map((entry, index) => (
                                                        <Cell
                                                            cursor="pointer"
                                                            fill={entry.amt > 0 ? wyzrTheme.palette.primary.light : wyzrTheme.palette.error.light}
                                                            key={`cell-${index}`}
                                                        />
                                                    ))}
                                                </Bar>
                                            </BarChart>
                                        </ResponsiveContainer>
                                    </Box>
                                </CardContent>
                            </Card>)
                        )}
                </Carousel>) : <LoaderCard title="Loading This Month Budget Data" />
        );
    }
}

export default ThisMonth;
